import { render, staticRenderFns } from "./GroupOrderDialog.vue?vue&type=template&id=860264e2&scoped=true&"
import script from "./GroupOrderDialog.vue?vue&type=script&lang=js&"
export * from "./GroupOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./GroupOrderDialog.vue?vue&type=style&index=0&id=860264e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860264e2",
  null
  
)

export default component.exports